export const INDUSTRIES = [
    {
        key: "Aerospace & Defense",
        value: "AEROSPACE_AND_DEFENSE"
    },
    {
        key: "Agriculture/Livestock",
        value: "AGRICULTURE_LIVESTOCK"
    },
    {
        key: "Automotive",
        value: "AUTOMOTIVE"
    },
    {
        key: "Business Services (Printing, etc.)",
        value: "BUSINESS_SERVICES"
    },
    {
        key: "Construction (Contractor, Home Building, etc.)",
        value: "CONSTRUCTION"
    },
    {
        key: "Consumer Services",
        value: "CONSUMER_SERVICES"
    },
    {
        key: "Education/Training",
        value: "EDUCATION_TRAINING"
    },
    {
        key:"Energy and Raw Materials",
        value: "ENERGY_AND_RAW_MATERIALS"
    },
    {
        key:"Environmental Services & Equipment",
        value: "ENVIRONMENTAL_SERVICES_AND_EQUIPMENT"
    },
    {
        key: "Finance",
        value: "FINANCE"
    },
    {
        key: "Government & Military",
        value: "GOVERNMENT_AND_MILITARY"
    },
    {
        key: "Health & Pharmaceuticals",
        value: "HEALTH_AND_PHARMACEUTICALS"
    },
    {
        key: "Human Resources",
        value: "HUMAN_RESOURCES"
    },
    {
        key: "Insurance",
        value: "INSURANCE"
    },
    {
        key: "Law",
        value: "LAW"
    },
    {
        key: "Lifestyle & Culture",
        value: "LIFESTYLE_AND_CULTURE"
    },
    {
        key: "Manufacturing",
        value: "MANUFACTURING"
    },
    {
        key: "Management Consulting",
        value: "MANAGEMENT_CONSULTING"
    },
    {
        key:"Media & Advertising",
        value: "MEDIA_AND_ADVERTISING"
    },
    {
        key: "Medicine",
        value: "MEDICINE"
    },
    {
        key: "Membership Organizations",
        value: "MEMBERSHIP_ORGANIZATIONS"
    },
    {
        key: "Non-Profit",
        value: "NON_PROFIT"
    },
    {
        key: "Other",
        value: "OTHER"
    },
    {
        key: "Real Estate",
        value: "REAL_ESTATE"
    },
    {
        key: "Religious Organizations",
        value: "RELIGIOUS_ORGANIZATIONS"
    },
    {
        key: "Retail",
        value: "RETAIL"
    },
    {
        key: "Security Products & Services",
        value: "SECURITY_PRODUCTS_AND_SERVICES"
    },
    {
        key: "Technology & Telecommunications",
        value: "TECHNOLOGY_AND_TELECOMMUNICATIONS"
    },
    {
        key: "Transport/Transportation Services/Logistics",
        value: "TRANSPORT_TRANSPORTATION_SERVICES_LOGISTICS"
    },
    {
        key: "Travel/Tourism/Hospitality",
        value: "TRAVEL_TOURISM_HOSPITALITY"
    }
];

export const SENIORITY = [
    {
        key: "Owner/Partner",
        value: "OWNER_PARTNER"
    },
    {
        key: "Chairman",
        value: "CHAIRMAN"
    },
    {
        key: "President",
        value: "PRESIDENT"
    },
    {
        key: "Chief Executive Officer",
        value: "CHIEF_EXECUTIVE_OFFICER"
    },
    {
        key: "Chief Operations Officer",
        value: "CHIEF_OPERATIONS_OFFICER"
    },
    {
        key: "Chief Digital Officer",
        value: "CHIEF_DIGITAL_OFFICER"
    },
    {
        key: "Chief Financial Officer/Controller",
        value: "CHIEF_FINANCIAL_OFFICER_CONTROLLER"
    },
    {
        key: "Chief HR Officer",
        value: "CHIEF_HR_OFFICER"
    },
    {
        key: "Chief Information/Chief Technology Officer",
        value: "CHIEF_INFORMATION_CHIEF_TECHNOLOGY_OFFICER"
    },
    {
        key: "Chief Investment Officer",
        value: "CHIEF_INVESTMENT_OFFICER"
    },
    {
        key: "Chief Marketing Officer",
        value: "CHIEF_MARKETING_OFFICER"
    },
    {
        key: "Chief Risk Officer",
        value: "CHIEF_RISK_OFFICER"
    },
    {
        key: "Other Chief Officer",
        value: "OTHER_CHIEF_OFFICER"
    },
    {
        key: "Executive Vice President/Senior Vice President/Vice President",
        value: "EXECUTIVE_VICE_PRESIDENT_SENIOR_VICE_PRESIDENT_VICE_PRESIDENT"
    },
    {
        key: "Director/Managing Director/Department Head",
        value: "DIRECTOR_MANAGING_DIRECTOR_DEPARTMENT_HEAD"
    },
    {
        key: "General Manager",
        value: "GENERAL_MANAGER"
    },
    {
        key: "Senior Manager/Manager",
        value: "SENIOR_MANAGER_MANAGER"
    },
    {
        key: "Supervisor",
        value: "SUPERVISOR"
    },
    {
        key: "Entry level",
        value: "ENTRY_LEVEL"
    },
    {
        key: "Other",
        value: "OTHER"
    }
];

export const JOB_TITLE = [
    {
        key: "Accounting/Finance",
        value: "ACCOUNTING_FINANCE"
    },
    {
        key: "Administration/Management",
        value: "ADMINISTRATION_MANAGEMENT"
    },
    {
        key: "Administrative/Clerical",
        value: "ADMINISTRATIVE_CLERICAL"
    },
    {
        key: "Banker",
        value: "BANKER"
    },
    {
        key: "Communications/PR",
        value: "COMMUNICATIONS_PR"
    },
    {
        key: "Compliance/Risk Management/Governance",
        value: "COMPLIANCE_RISK_MANAGEMENT_GOVERNANCE"
    },
    {
        key: "Developer/Programmer",
        value: "DEVELOPER_PROGRAMMER"
    },
    {
        key: "Energy sector professional",
        value: "ENERGY_SECTOR_PROFESSIONAL"
    },
    {
        key: "Entrepreneur/small business professional",
        value: "ENTREPRENEUR_SMALL_BUSINESS_PROFESSIONAL"
    },
    {
        key: "Facilities/Maintenance",
        value: "FACILITIES_MAINTENANCE"
    },
    {
        key: "Family Office",
        value: "FAMILY_OFFICE"
    },
    {
        key: "Financial Advisor",
        value: "FINANCIAL_ADVISOR"
    },
    {
        key: "Government & Policy Makers",
        value: "GOVERNMENT_AND_POLICY_MAKERS"
    },
    {
        key: "Human Resources",
        value: "HUMAN_RESOURCES"
    },
    {
        key: "Information Technology (IT)",
        value: "INFORMATION_TECHNOLOGY"
    },
    {
        key: "Institutional Investor",
        value: "INSTITUTIONAL_INVESTOR"
    },
    {
        key: "Legal Logistics/Planning",
        value: "LEGAL_LOGISTICS_PLANNING"
    },
    {
        key: "Market Research",
        value: "MARKET_RESEARCH"
    },
    {
        key: "Marketing/Advertising",
        value: "MARKETING_ADVERTISING"
    },
    {
        key: "Medical/Healthcare",
        value: "MEDICAL_HEALTHCARE"
    },
    {
        key: "Operations/Production",
        value: "OPERATIONS_PRODUCTION"
    },
    {
        key: "Other",
        value: "OTHER"
    },
    {
        key: "Other Financial Professional",
        value: "OTHER_FINANCIAL_PROFESSIONAL"
    },
    {
        key: "Portfolio Analyst",
        value: "PORTFOLIO_ANALYST"
    },
    {
        key: "Production/Manufacturing",
        value: "PRODUCTION_MANUFACTURING"
    },
    {
        key: "Purchasing/Procurement",
        value: "PURCHASING_PROCUREMENT"
    },
    {
        key: "Quality Assurance/ Quality Control",
        value: "QUALITY_ASSURANCE_QUALITY_CONTROL"
    },
    {
        key: "Research & Development",
        value: "RESEARCH_AND_DEVELOPMENT"
    },
    {
        key: "Retired",
        value: "RETIRED"
    },
    {
        key: "Risk Manager",
        value: "RISK_MANAGER"
    },
    {
        key: "Sales/Business",
        value: "SALES_BUSINESS"
    },
    {
        key: "Service Design/Engineering",
        value: "SERVICE_DESIGN_ENGINEERING"
    },
    {
        key: "Stockbroker",
        value: "STOCKBROKER"
    },
    {
        key: "Student",
        value: "STUDENT"
    },
    {
        key: "Training & Education",
        value: "TRAINING_AND_EDUCATION"
    },
    {
        key: "Transportation/Freight and Logistics/Supply Chain",
        value: "TRANSPORTATION_FREIGHT_AND_LOGISTICS_SUPPLY_CHAIN"
    },
    {
        key: "Venture Capitalist",
        value: "VENTURE_CAPITALIST"
    },
    {
        key: "Wealth Manager",
        value: "WEALTH_MANAGER"
    }
];
